import { getForecasterTweets, getForecasterTelegram } from "@/Groups/Forecasters/private/api/getData";
import { getDailyHighlightsTweets, getDailyHighlightsTelegram } from "@/Groups/Forecasters/private/api/dailyHighlights";
import { getForecasterUserAssetsTweets, getForecasterUserAssetsTelegram } from "@/Groups/Forecasters/private/api/userAssets";
import { fetchForecasterByUrl } from "@/Groups/Forecasters/private/api/nextPagination";
import { searchForecasterByCoinTwitter, searchForecasterByCoinTelegram } from "@/Groups/Forecasters/private/api/searchForecasterByCoin";
import { getCoinsByCustomTag } from "@/Groups/Forecasters/private/api/getCustomCoins";
import { getTopGainers } from "@/Groups/Forecasters/private/api/topGainersCoins";
import { hideTweet, hideTelegramMessage } from "@/Groups/Forecasters/private/api/hidePost";
import {
  getForecasterTweetsBookmarks,
  addForecasterTweetBookmark,
  removeForecasterTweetBookmark,
  getForecasterTelegramBookmarks,
  addForecasterTelegramBookmark,
  removeForecasterTelegramBookmark,
} from "@/Groups/Forecasters/private/api/bookmark.js";

import { twitter } from "../private/tests/testData";
import { telegram } from "../private/tests/telegramData";

export default {
  namespaced: true,

  state: {
    //Навигация
    activeIndex: 0,

    //Фильтр
    isDailyFilterActived: false,
    isUserBriefcaseFilterActived: false,
    isSearchCoinsFilterActived: false,
    isPopularPonFilterActived: false,
    isTopGainersFilterActived: false,
    isBookmarksFilterActived: false,
    selectedCoins: [],

    //Twitter данные
    twitter: {
      list: {},
      renderMap: {},
      listDailyHighlights: {},
      next: null,
      isLoading: false,
      isReady: false,
      isEnglishLang: false,
    },

    //Telegram данные
    telegram: {
      list: {},
      renderMap: {},
      listDailyHighlights: {},
      next: null,
      isLoading: false,
      isReady: false,
      isEnglishLang: false,
    },
  },

  actions: {
    //------------------------------------------------------
    //Навигация
    //------------------------------------------------------
    async init({ dispatch }) {
      await dispatch("fetchDataAll");
    },
    //XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX


    //------------------------------------------------------
    //Работа с данными
    //------------------------------------------------------
    async fetchDataAll({ commit }) {
      commit("SET_LOADING", true);
      commit("CLEAR_ITEMS");
      commit("SET_FILTERS", {
        isDailyFilterActived: false,
        isUserBriefcaseFilterActived: false,
        isSearchCoinsFilterActived: false,
        isPopularPonFilterActived: false,
        isTopGainersFilterActived: false,
        isBookmarksFilterActived: false,
        selectedCoins: [],
      });
      try {
        const [twitterData, telegramData] = await Promise.all([getForecasterTweets(), getForecasterTelegram()]);
        commit("ADD_ITEMS", [
          { type: "twitter", itemsByDate: twitterData.twitter },
          { type: "telegram", itemsByDate: telegramData.telegram }
        ]);
        commit("SET_PAGINATION", [
          { type: "twitter", next: twitterData.next },
          { type: "telegram", next: telegramData.next }
        ]);
        commit("SET_READY", true);
      } catch (error) {
        console.error("fetchDataAll error:", error);
        commit("CLEAR_ITEMS");
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchNextPage({ state, commit }) {
      commit("SET_LOADING", true);
      try {
        const [twitterData, telegramData] = await Promise.all([
          fetchForecasterByUrl(state.twitter.next),
          fetchForecasterByUrl(state.telegram.next),
        ]);
        commit("ADD_ITEMS", [
          { type: "twitter", itemsByDate: twitterData.twitter },
          { type: "telegram", itemsByDate: telegramData.telegram }
        ]);
        commit("SET_PAGINATION", [
          { type: "twitter", next: twitterData.next },
          { type: "telegram", next: telegramData.next }
        ]);
      } catch (error) {
        console.error(`${type}/fetchNextPage error:`, error);
      } finally {
        commit("SET_LOADING", false);
      }               
    },

    async removeTweet({ state, commit, dispatch }, { id }){
       try {
        commit("REMOVE_POST", { type: "twitter", id });
        await hideTweet(id);
      } catch (error) {
        console.error("removeTweet error:", error);
      }
    },

    async removeTelegramMessage({ state, commit, dispatch }, { id }){
      try {
        commit("REMOVE_POST", { type: "telegram", id });
        await hideTelegramMessage(id);
      } catch (error) {
        console.error("removeTelegramMessage error:", error);
      }
    },
    //XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX


    //------------------------------------------------------
    //Работа с фильтрами
    //------------------------------------------------------
    async toggleBookmarksFilter({ state, commit, dispatch }) {
      const isActive = !state.isBookmarksFilterActived;

      // Сбрасываем остальные фильтры
      commit("SET_FILTERS", {
        isDailyFilterActived: false,
        isUserBriefcaseFilterActived: false,
        isSearchCoinsFilterActived: false,
        isPopularPonFilterActived: false,
        isTopGainersFilterActived: false,
        isBookmarksFilterActived: isActive,
        selectedCoins: [],
      });

      commit("CLEAR_ITEMS");
      commit("SET_LOADING", true);

      if (!isActive) {
        // если выключаем фильтр — подгружаем обычные данные
        await dispatch("fetchDataAll");
      } else {
        try {
          const [twitterData, telegramData] = await Promise.all([
            getForecasterTweetsBookmarks(),
            getForecasterTelegramBookmarks(),
          ]);

          commit("ADD_ITEMS", [
            { type: "twitter", itemsByDate: twitterData.twitter },
            { type: "telegram", itemsByDate: telegramData.telegram },
          ]);
          commit("SET_READY", true);
        } catch (error) {
          console.error("toggleBookmarksFilter error:", error);
        }
      }

      commit("SET_LOADING", false);
    },

    //Переключение фильтра "Выжимка"
    async toggleDailyFilter({ state, commit, dispatch }) {
      const isActive = !state.isDailyFilterActived;

      commit("SET_FILTERS", {
        isDailyFilterActived: isActive,
        isUserBriefcaseFilterActived: false,
        isSearchCoinsFilterActived: false,
        isPopularPonFilterActived: false,
        isTopGainersFilterActived: false,
        isBookmarksFilterActived: false,
        selectedCoins: [],
      });

      commit("CLEAR_ITEMS");
      commit("SET_LOADING", true);
      if(!isActive) await dispatch("fetchDataAll");
      else{
        try {
          const [twitterData, telegramData] = await Promise.all([getDailyHighlightsTweets(), getDailyHighlightsTelegram()]);
          commit("SET_DAILY_HIGHLIGHTS", [
            { type: "twitter", highlights: twitterData.daily_highlights },
            { type: "telegram", highlights: telegramData.daily_highlights }
          ]),
          commit("SET_READY", true);
        } catch (error) {
          console.error("toggleDailyFilter error:", error);
        }
      }
      commit("SET_LOADING", false);
    },

    //Переключение фильтра "Портфель пользователя"
    async toggleUserAssetsFilter({ state, commit, dispatch }) {
      const isActive = !state.isUserBriefcaseFilterActived;

      //Сбрасываем все остальные фильтры
      commit("SET_FILTERS", {
        isDailyFilterActived: false,
        isUserBriefcaseFilterActived: isActive,
        isSearchCoinsFilterActived: false,
        isPopularPonFilterActived: false,
        isTopGainersFilterActived: false,
        isBookmarksFilterActived: false,
        selectedCoins: [],
      });

      commit("CLEAR_ITEMS");
      commit("SET_LOADING", true);
      if(!isActive) await dispatch("fetchDataAll");
      else{
        try {
          const [twitterData, telegramData] = await Promise.all([
            getForecasterUserAssetsTweets(),
            getForecasterUserAssetsTelegram(),
          ]);
          commit("ADD_ITEMS", [
            { type: "twitter", itemsByDate: twitterData.twitter },
            { type: "telegram", itemsByDate: telegramData.telegram }
          ]);
          commit("SET_READY", true);
        } catch (error) {
          console.error("toggleUserAssetsFilter error:", error);
        }
      }
      commit("SET_LOADING", false);
    },

    //---------------------Фильтрация по монетам
    //Фильтр по выбранным монетам
    async fetchSelectedCoinsData({ state, commit, dispatch }) {
      const coins = state.selectedCoins;
      if(!coins.length){
        await dispatch("fetchDataAll");
        commit("SET_FILTERS", {
          isDailyFilterActived: false,
          isUserBriefcaseFilterActived: false,
          isSearchCoinsFilterActived: false,
          isPopularPonFilterActived: false,
          isTopGainersFilterActived: false,
          selectedCoins: [],
        });
        return;
      }
      const coinIds = coins.map(c => c.api_id);
      commit("CLEAR_ITEMS");
      commit("SET_LOADING", true);
      try {
        const [twitterData, telegramData] = await Promise.all([
          searchForecasterByCoinTwitter(coinIds),
          searchForecasterByCoinTelegram(coinIds),
        ]);
        commit("ADD_ITEMS", [
          { type: "twitter", itemsByDate: twitterData.twitter },
          { type: "telegram", itemsByDate: telegramData.telegram }
        ]);
        commit("SET_READY", true);
      } catch (error) {
        console.error("fetchSelectedCoinsData error:", error);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    //Фильтр через поиск монет
    async addCoinToStore({ state, commit, dispatch }, coin) {
      //Сбрасываем все остальные фильтры
      if(!state.isSearchCoinsFilterActived){
        commit("SET_FILTERS", {
          isDailyFilterActived: false,
          isUserBriefcaseFilterActived: false,
          isSearchCoinsFilterActived: true,
          isPopularPonFilterActived: false,
          isTopGainersFilterActived: false,
          isBookmarksFilterActived: false,
          selectedCoins: [],
        });
      }
      const updatedCoins = state.selectedCoins.some(c => c.api_id === coin.api_id)
        ? state.selectedCoins : [...state.selectedCoins, coin];

      commit("SET_FILTERS", { selectedCoins: updatedCoins });
      await dispatch("fetchSelectedCoinsData");
    },

    //Фильтр популярное в PON
    async togglePopularCoins({ state, commit, dispatch }) {
      const isActive = !state.isPopularPonFilterActived;

      commit("SET_FILTERS", {
        isDailyFilterActived: false,
        isUserBriefcaseFilterActived: false,
        isSearchCoinsFilterActived: false,
        isPopularPonFilterActived: isActive,
        isTopGainersFilterActived: false,
        isBookmarksFilterActived: false,
        selectedCoins: [],
      });

      if (!isActive) await dispatch("fetchDataAll");
      else {
        try {
          const data = await getCoinsByCustomTag("На слуху");
          const coins = Array.isArray(data?.coins) ? data.coins : data || [];
          const normalizedCoins = coins.map(c => ({ ...c, api_id: c.api_id || c.id }));
          commit("SET_FILTERS", { selectedCoins: normalizedCoins });
          await dispatch("fetchSelectedCoinsData");
        } catch (error) {
          console.error("fetchCustomTagCoins error:", error);
        }   
      }
    },

    //Фильтр гейнеры
    async toggleTopGainers({ state, commit, dispatch }) {
      const isActive = !state.isTopGainersFilterActived;

      commit("SET_FILTERS", {
        isDailyFilterActived: false,
        isUserBriefcaseFilterActived: false,
        isSearchCoinsFilterActived: false,
        isPopularPonFilterActived: false,
        isTopGainersFilterActived: isActive,
        isBookmarksFilterActived: false,
        selectedCoins: [],
      });

      if (!isActive) await dispatch("fetchDataAll");
      else {
        try {
          const data = await getTopGainers();
          const coins = Array.isArray(data?.coins) ? data.coins : data || [];
          const normalizedCoins = coins.map(c => ({ ...c, api_id: c.api_id || c.id }));
          commit("SET_FILTERS", { selectedCoins: normalizedCoins });
          await dispatch("fetchSelectedCoinsData");
        } catch (error) {
          console.error("fetchCustomTagCoins error:", error);
        }   
      }
    },

    //Убираем одну монету
    async removeSelectedCoin({ state, commit, dispatch }, coin) {
      if (!coin) {
        commit("SET_FILTERS", { selectedCoins: [] });
        return;
      }
      const updatedCoins = state.selectedCoins.filter(c => c.api_id !== coin.api_id);
      commit("SET_FILTERS", { selectedCoins: updatedCoins });
      await dispatch("fetchSelectedCoinsData");
    },
    //XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX

    //------------------------------------------------------
    //Переключение языка
    //------------------------------------------------------
    toggleLanguage({ state, commit }, type) {
      commit("SET_LANGUAGE", { type, value: !state[type].isEnglishLang });
    },
    //XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX


    //------------------------------------------------------
    // Добавление / удаление поста из избранного
    //------------------------------------------------------
    async toggleBookmark({ commit }, { type, id, isBookmarked }) {
      //Сначала — мгновенное обновление UI
      commit("SET_BOOKMARK_STATE", { type, id, value: !isBookmarked });
      //Параллельно — запрос на сервер (без ожидания UI)
      try {
        if (!isBookmarked) {
          if (type === "twitter") await addForecasterTweetBookmark(id);
          else await addForecasterTelegramBookmark(id);
        } else {
          if (type === "twitter") await removeForecasterTweetBookmark(id);
          else await removeForecasterTelegramBookmark(id);
        }
      } catch (error) {
        console.error("toggleBookmark error:", error);
        //В случае ошибки откатываем визуально
        commit("SET_BOOKMARK_STATE", { type, id, value: isBookmarked });
      }
    },
    //XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX

    //Навигация
    async setActiveTab({ commit }, index) {
      commit("SET_ACTIVE_TAB", index);
    },
  },

  mutations: {
    //------------------------------------------------------
    //Навигация
    //------------------------------------------------------
    SET_ACTIVE_TAB(state, index) {
      state.activeIndex = index;
    },
    //XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
    

    //------------------------------------------------------
    //Работа с данными
    //------------------------------------------------------
    //Добавить данные в хрнаилище
    ADD_ITEMS(state, data) {
      data.forEach(dataItem => {
        const { type, itemsByDate } = dataItem;
        const postKey = type === "twitter" ? "tweets" : "telegram";
        //Форматирование данных для дальнейшего использования в компонентах
        Object.entries(itemsByDate).forEach(([date, data]) => {
          if (!state[type].renderMap[date]) state[type].renderMap[date] = [];
          state[type].listDailyHighlights[date] = data.daily_highlight || null;

          if (Array.isArray(data[postKey])) {
            data[postKey].forEach((item) => {
              if(!state[type].renderMap[date].includes(item.id)) {
                state[type].renderMap[date].unshift(item.id);
              }
              if (!state[type].list[item.id]) {
                state[type].list[item.id] = { ...item };
              }
            });
          }
        });
        //Сортировка постов по времени публикации
        Object.keys(state[type].renderMap).forEach((date) => {
          state[type].renderMap[date].sort((a, b) => {
            const tA = new Date(state[type].list[a]?.created_at).getTime();
            const tB = new Date(state[type].list[b]?.created_at).getTime();
            return tB - tA;
          });
        });
      });
    },
    //Добавить данные в выжимку
    SET_DAILY_HIGHLIGHTS(state, data) {
      data.forEach(dataItem => {
        const { type, highlights } = dataItem;
        const postKey = type === "twitter" ? "tweets" : "telegram";
        Object.entries(highlights).forEach(([date, highlightObj]) => {
          state[type].listDailyHighlights[date] =
            highlightObj.daily_highlights?.[0] || null;
          if (!state[type].renderMap[date]) state[type].renderMap[date] = [];
          if (Array.isArray(highlightObj[postKey])) {
            highlightObj[postKey].forEach((item) => {
              if (!state[type].renderMap[date].includes(item.id)) {
                state[type].renderMap[date].unshift(item.id);
              }
              if (!state[type].list[item.id]) {
                state[type].list[item.id] = { ...item };
              }
            });
          }
        });
      })
    },
    //Отметить процесс загрузки данных
    SET_LOADING(state, value) {
      state['twitter'].isLoading = value;
      state['telegram'].isLoading = value;
    },
    ///Отметитть готовность к отображению
    SET_READY(state, value) {
      state['twitter'].isReady = value;
      state['telegram'].isReady = value;
    },
    //Почистить хранилище постов
    CLEAR_ITEMS(state) {
      const data = ['twitter', 'telegram'];
      data.forEach(item => {
        state[item].list = {};
        state[item].renderMap = {};
        state[item].next = null;
        state[item].isReady = false;
      });
    },
    //Установить пагинацию
    SET_PAGINATION(state, data) {
      data.forEach(item => {
        state[item.type].next = item.next;
      })
    },
    //Удаление поста
    REMOVE_POST(state, { type, id }) {
      //Удаляем из основного списка
      if (state[type].list[id]) {
        delete state[type].list[id];
      }
      //Удаляем из всех дат в renderMap
      Object.keys(state[type].renderMap).forEach((date) => {
        state[type].renderMap[date] = state[type].renderMap[date].filter(
          (postId) => postId !== id
        );
        if (state[type].renderMap[date].length === 0) {
          delete state[type].renderMap[date];
        }
      });
    },
    //XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX


    //------------------------------------------------------
    //Работа с фильтрами
    //------------------------------------------------------
    SET_FILTERS(state, payload) {
      Object.assign(state, payload);
    },

    SET_LANGUAGE(state, { type, value }) {
      state[type].isEnglishLang = value;
    },
    //XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX

    //------------------------------------------------------
    // Избранное
    //------------------------------------------------------
    SET_BOOKMARK_STATE(state, { type, id, value }) {
      const post = state[type].list[id];
      if (post) post.is_bookmarked = value;
    },
    //XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
  },

  getters: {
    //Навигация
    activeIndex: (state) => state.activeIndex,
    //Язык отображения постов
    isEnglishLang: (state) => (type) => state[type].isEnglishLang,
    //Флаг процесса загрузки постов
    isLoading: (state) => (type) => state[type].isLoading,
    //Флаг готовности данных к отобоажению
    isReady: (state) => (type) => state[type].isReady,
    //Флаг активности фильтра по выжимке
    isDailyFilterActived: (state) => state.isDailyFilterActived,
    //Флаг активности фильтра по портфелю
    isUserBriefcaseFilterActived: (state) => state.isUserBriefcaseFilterActived,
    //Флаг активности фильтра по популярному в PON
    isPopularPonFilterActived: (state) => state.isPopularPonFilterActived,
    //Флаг активности фильтра по гейнрам
    isTopGainersFilterActived: (state) => state.isTopGainersFilterActived,
    //Список постов
    list: (state) => (type) => state[type].list,
    //Список выжимок
    listDailyHighlights: (state) => (type) => state[type].listDailyHighlights,
    //Карта отрисовки постов
    renderMap: (state) => (type) => state[type].renderMap,
    //Ссылка на след. пагинацию
    nextPage: (state) => (type) => state[type].next,
    //Выбранные монеты
    selectedCoins: (state) => state.selectedCoins,
    //Cостояние фильтра избранного
    isBookmarksFilterActived: (state) => state.isBookmarksFilterActived,
  },
}